import React, { useEffect, useState } from "react";

// UX
import CardSkinPreparationUX from "./CardSkinPreparationUX";
import { ACTION, checkHideButton } from "./CardOtherForm";
import PreOPButtonAction from "./PreOPButtonAction";
import { useIntl } from "react-intl";
import { Form, FormGroup, FormField, Dropdown, Button } from "semantic-ui-react";

type AddDataProps = {
  index: number;
  type: string;
  item: any;
  disabled: boolean;
  onAddData: Function;
  onDeleteData: Function;
  onChangeData: Function;
  // Options
  orVaginaOptions?: any[];
  orSkinAreaOptions?: any[];
  handleAddVaginaOptions?: any;
  handleAddSkinAreaOptions?: any;
};

type OptionType = {
  key: string;
  text: string;
  value: string;
};

type OptionsState = {
  planAndImpleHrOptions: OptionType[];
  orMedicationOptions: OptionType[];
  orNDOptions: OptionType[];
  orGoal: OptionType[];
  orEvaluation: OptionType[];
};

export const SKIN_PREPARATION = "skinPreparation";
const CARD_SKIN_PREPARATION = "CardSkinPreparation";

const SKIN_DATA_ITEMS = {
  skinArea: "",
  solution: "",
};

const CardSkinPreparation = (props: any) => {
  const intl = useIntl();
  const [options, setOptions] = useState<OptionsState>({
    planAndImpleHrOptions: [],
    orMedicationOptions: [],
    orNDOptions: [],
    orGoal: [],
    orEvaluation: [],
  });

  const updateOptions = (
    holdingRoomData: any,
    masterKey: string,
    optionsKey: keyof OptionsState,
    mapHoldingRoomData: (item: any) => OptionType
  ) => {
    const masterData = props.masterOptions?.[masterKey] || [];

    // แก้ไขข้อมูลให้อยู่ในรูปแบบ array
    let valueInOption = Array.isArray(holdingRoomData) ? holdingRoomData : [holdingRoomData];

    // ค้นหา option ที่เพิ่มขึ้นมาเอง
    const optionData = (valueInOption || [])
      .filter(
        (item: any) =>
          (item && typeof item === "string") ||
          (item?.medicine_name && typeof item?.medicine_name === "string")
      )
      .map(mapHoldingRoomData);

    // รวม option จาก masterData และ options (option ที่เพิ่มขึ้นเอง)
    const combinedOption = [...new Set([...masterData, ...(options[optionsKey] || [])])];

    // ตรวจสอบหาเฉพาะ optionData ที่ไม่ซ้ำใน combinedOption
    const newOptions = optionData.filter(
      (item: any) => !combinedOption.some((option) => option.value === item.value)
    );

    setOptions((prevOptions) => ({
      ...prevOptions,
      [optionsKey]: newOptions.length ? [...combinedOption, ...newOptions] : combinedOption,
    }));
  };

  // orMedication
  useEffect(() => {
    updateOptions(
      props.data?.data?.medication_item,
      "orMedication",
      "orMedicationOptions",
      (item) => ({
        key: item.medicine_name,
        text: item.medicine_name,
        value: item.medicine_name,
      })
    );
  }, [props.masterOptions?.orMedication, props.data?.data?.medication_item]);

  useEffect(() => {
    // const nursingDiagnosisData = props.data?.data?.nursing_diagnosis_item;

    const raw = {
      nursing_diagnosis: props.data?.data?.nursing_diagnosis ?? "",
      goal: props.data?.data?.goal ?? [],
      plan_and_implementation:
        props.data?.data?.plan_and_implementation ?? [],
      evaluation: props.data?.data?.evaluation ?? [],
    };

    const nursingDiagnosisData = Array.isArray(raw) ? raw : raw ? [raw] : [];


    const allNursingDiagnosis = [
      ...new Set((nursingDiagnosisData || []).flatMap((item: any) => item?.nursing_diagnosis)),
    ];
    updateOptions(allNursingDiagnosis, "orNursingDiagnosis", "orNDOptions", (item) => ({
      key: item,
      text: item,
      value: item,
    }));

    const allGoal = [...new Set((nursingDiagnosisData || []).flatMap((item: any) => item?.goal))];
    updateOptions(allGoal, "orGoal", "orGoal", (item) => ({
      key: item,
      text: item,
      value: item,
    }));

    const allPlanAndImpleHr = [
      ...new Set(
        (nursingDiagnosisData || []).flatMap((item: any) => item?.plan_and_implementation)
      ),
    ];
    updateOptions(allPlanAndImpleHr, "planAndImpleHr", "planAndImpleHrOptions", (item) => ({
      key: item,
      text: item,
      value: item,
    }));

    const allEvaluations = [
      ...new Set((nursingDiagnosisData || []).flatMap((item: any) => item?.evaluation)),
    ];
    updateOptions(allEvaluations, "orEvaluation", "orEvaluation", (item) => ({
      key: item,
      text: item,
      value: item,
    }));
  }, [
    props.masterOptions?.orNursingDiagnosis,
    props.masterOptions?.orGoal,
    props.masterOptions?.planAndImpleHr,
    props.masterOptions?.orEvaluation,
    props.data?.data,
  ]);

  const skinPreparationData = {
    ...props.data?.data,
    skin_scrub_items: props.data?.data?.skin_scrub_items || [SKIN_DATA_ITEMS],
    paint_area_items: props.data?.data?.paint_area_items || [SKIN_DATA_ITEMS],
  };

  const handleSave = (action: string) => (e: any, v: any) => {
    props.onSave(action)(e, {
      ...v,
      formCode: CARD_SKIN_PREPARATION,
      formName: "Skin Preparation",
      key: SKIN_PREPARATION,
    });
  };

  const handleAddVaginaOptions = (e: any, { value }: any) => {
    props.setProp("masterOptions.orVagina", [
      { text: value, value: value, key: value },
      ...props.masterOptions?.orVagina,
    ]);
  };

  const handleAddSkinAreaOptions = (e: any, { value }: any) => {
    props.setProp("masterOptions.orSkinArea", [
      ...props.masterOptions?.orSkinArea,
      { text: value, value: value, key: value },
    ]);
  };

  const handleChangeValueSkinScrub = (_event: any, data: any) => {
    props.setProp(`PerioperativeNursingSequence.skinPreparation.data.${data.name}`, data.value);
  };

  const handleAddSkinScrub = (type: string) => {
    const items: any[] = skinPreparationData?.[type] || [];

    items.push(JSON.parse(JSON.stringify(SKIN_DATA_ITEMS)));
    handleChangeValueSkinScrub(null, { name: type, value: items });
  };

  const handleDeleteSkinScrub = (index: number, type: string) => {
    const items: any[] = skinPreparationData?.[type] || [];

    if (items.length > 1) {
      items.splice(index, 1);
      handleChangeValueSkinScrub(null, { name: type, value: items });
    }
  };

  const handleChangeSkinScrub = (index: number, value: any, key: string, type: string) => {
    let items: any[] = JSON.parse(JSON.stringify(skinPreparationData?.[type] || []));

    if (!items[index]) {
      items[index] = JSON.parse(JSON.stringify(SKIN_DATA_ITEMS));
    }

    items[index][key] = value;
    handleChangeValueSkinScrub(null, { name: type, value: items });
  };

  const handleAddOptions = (e: any, v: any) => {
    let newOption = { text: v.value, value: v.value, key: v.value };

    const optionMap: { [key: string]: keyof OptionsState } = {
      plan_and_implementation: "planAndImpleHrOptions",
      nursing_diagnosis: "orNDOptions",
      goal: "orGoal",
      evaluation: "orEvaluation",
    };

    const key = optionMap[v.name];
    if (key) {
      setOptions({ ...options, [key]: [...options[key], newOption] });
    }
  };

  const handleChangeArrayData = (key: string, index: number, data: any) => {
    let result = [...props.data?.data?.[key]];
    result[index][data.name] = data.value;

    props.runSequence({
      sequence: "PerioperativeNursing",
      action: "SET_DATA",
      cardKey: SKIN_PREPARATION,
      key: "nursing_diagnosis_item",
      value: result,
    });
  };

  const handleAddArrayData = () => {
    let result = [...skinPreparationData?.nursing_diagnosis_item];

    result.push({
      nursing_diagnosis: "",
      goal: [],
      plan_and_implementation: [],
      evaluation: [],
    });

    props.setProp(
      "PerioperativeNursingSequence.skinPreparation.data.nursing_diagnosis_item",
      result
    );
  };

  const handleRemoveArrayData = (index: number) => {
    let result = [...skinPreparationData?.nursing_diagnosis_item];
    result.splice(index, 1);

    props.setProp(
      "PerioperativeNursingSequence.skinPreparation.data.nursing_diagnosis_item",
      result
    );
  };

  return (
    <>
      <CardSkinPreparationUX
        // data
        status={props.data?.status}
        isSurgicalSkinScrub={skinPreparationData?.is_surgical_skin_scrub}
        isSurgicalSite={skinPreparationData?.is_surgical_site}
        isVagina={skinPreparationData?.is_vagina}
        vagina={skinPreparationData?.vagina}
        handleAddVaginaOptions={handleAddVaginaOptions}
        woundClassification={skinPreparationData?.wound_classification}
        nurseDiagnosis={skinPreparationData?.nursing_diagnosis}
        goal={skinPreparationData?.goal}
        planAndImplementation={skinPreparationData?.plan_and_implementation}
        evaluation={skinPreparationData?.evaluation}
        evaluationCheck={skinPreparationData?.evaluation_check}
        evaluationDetail={skinPreparationData?.evaluation_detail}
        // options
        orVaginaOptions={props.masterOptions?.orVagina}
        // callback
        onChangeData={props.onChangeData}
        // config
        config={{
          disabledVagina: !skinPreparationData?.is_vagina,
          hideStatus: checkHideButton(props.data, "STATUS"),
        }}
        // Element
        AddSkinScrub={
          <Form
            style={
              skinPreparationData?.is_surgical_skin_scrub ? { width: "100%" } : { display: "none" }
            }
          >
            {(skinPreparationData?.skin_scrub_items || [SKIN_DATA_ITEMS])?.map(
              (item: any, index: number) => {
                return (
                  <SkinScrubAddData
                    key={`skin_scrub_${index}`}
                    index={index}
                    item={item}
                    type={"skin_scrub_items"}
                    // config
                    disabled={!skinPreparationData?.is_surgical_skin_scrub}
                    // callback
                    onAddData={handleAddSkinScrub}
                    onDeleteData={handleDeleteSkinScrub}
                    onChangeData={handleChangeSkinScrub}
                    // addition
                    handleAddSkinAreaOptions={handleAddSkinAreaOptions}
                    handleAddVaginaOptions={handleAddVaginaOptions}
                    orVaginaOptions={props.masterOptions?.orVagina}
                    orSkinAreaOptions={props.masterOptions?.orSkinArea}
                  />
                );
              }
            )}
          </Form>
        }
        AddPaintArea={
          <Form
            style={
              skinPreparationData?.is_surgical_skin_scrub ? { width: "100%" } : { display: "none" }
            }
          >
            {(skinPreparationData?.paint_area_items || [SKIN_DATA_ITEMS])?.map(
              (item: any, index: number) => {
                return (
                  <SkinScrubAddData
                    key={`paint_area_${index}`}
                    index={index}
                    item={item}
                    type={"paint_area_items"}
                    // config
                    disabled={!skinPreparationData?.is_surgical_skin_scrub}
                    // callback
                    onAddData={handleAddSkinScrub}
                    onDeleteData={handleDeleteSkinScrub}
                    onChangeData={handleChangeSkinScrub}
                    // addition
                    handleAddSkinAreaOptions={handleAddSkinAreaOptions}
                    handleAddVaginaOptions={handleAddVaginaOptions}
                    orVaginaOptions={props.masterOptions?.orVagina}
                    orSkinAreaOptions={props.masterOptions?.orSkinArea}
                  />
                );
              }
            )}
          </Form>
        }
        nursingDiagnosisItem={
          <>
            {/* {(skinPreparationData?.nursing_diagnosis_item || [])?.map(
              (item: any, index: number) => {
                return (
                  <Form>
                    <FormGroup
                      style={{
                        backgroundColor: "rgb(253, 248, 221)",
                        padding: "30px 10px",
                        marginTop: "2rem",
                      }}
                    >
                      <FormField width={16}>
                        <FormGroup inline={true}>
                          <FormField inline={true} width={7}>
                            <label style={{ width: "100%", maxWidth: "max-content" }}>
                              Nursing Diagnosis
                            </label>
                            <Dropdown
                              allowAdditions={true}
                              clearable={true}
                              fluid={true}
                              name="nursing_diagnosis"
                              onAddItem={handleAddOptions}
                              onChange={(_event: any, data: any) =>
                                handleChangeArrayData("nursing_diagnosis_item", index, data)
                              }
                              options={options.orNDOptions || []}
                              search={true}
                              selection={true}
                              style={{ width: "100%" }}
                              value={item?.nursing_diagnosis}
                            ></Dropdown>
                          </FormField>
                          <FormField inline={true} width={8}>
                            <label>Goal</label>
                            <Dropdown
                              allowAdditions={true}
                              clearable={true}
                              fluid={true}
                              multiple={true}
                              name="goal"
                              onAddItem={handleAddOptions}
                              onChange={(_event: any, data: any) =>
                                handleChangeArrayData("nursing_diagnosis_item", index, data)
                              }
                              options={options.orGoal || []}
                              search={true}
                              selection={true}
                              style={{ width: "100%" }}
                              value={item?.goal || []}
                            ></Dropdown>
                          </FormField>
                          <FormField
                            inline={true}
                            width={1}
                            style={{
                              minWidth: "max-content",
                              padding: 0,
                              marginRight: "-0.5rem",
                            }}
                          >
                            {index === 0 ? (
                              <Button
                                color="green"
                                icon="plus"
                                size="mini"
                                style={{ margin: "0 0 0 10px" }}
                                onClick={handleAddArrayData}
                              ></Button>
                            ) : (
                              <Button
                                color="red"
                                icon="minus"
                                size="mini"
                                style={{ margin: "0 0 0 10px" }}
                                onClick={() => handleRemoveArrayData(index)}
                              ></Button>
                            )}
                          </FormField>
                        </FormGroup>
                        <FormGroup inline={true}>
                          <FormField inline={true} width={7}>
                            <label style={{ width: "100%", maxWidth: "max-content" }}>
                              Plan and implementation
                            </label>
                            <Dropdown
                              allowAdditions={true}
                              clearable={true}
                              fluid={true}
                              multiple={true}
                              name="plan_and_implementation"
                              onAddItem={handleAddOptions}
                              onChange={(_event: any, data: any) =>
                                handleChangeArrayData("nursing_diagnosis_item", index, data)
                              }
                              options={options.planAndImpleHrOptions || []}
                              search={true}
                              selection={true}
                              style={{ width: "100%" }}
                              value={item.plan_and_implementation || []}
                            ></Dropdown>
                          </FormField>
                          <FormField inline={true} width={8}>
                            <label>Evaluation</label>
                            <Dropdown
                              allowAdditions={true}
                              clearable={true}
                              fluid={true}
                              multiple={true}
                              name="evaluation"
                              onAddItem={handleAddOptions}
                              onChange={(_event: any, data: any) =>
                                handleChangeArrayData("nursing_diagnosis_item", index, data)
                              }
                              options={options.orEvaluation}
                              search={true}
                              selection={true}
                              style={{ width: "100%" }}
                              value={item?.evaluation || []}
                            ></Dropdown>
                          </FormField>
                          <FormField inline={true} width={1}></FormField>
                        </FormGroup>
                      </FormField>
                    </FormGroup>
                  </Form>
                );
              }
            )} */}

            {/* CU */}

            <Form>
              <FormGroup
                style={{
                  backgroundColor: "rgb(253, 248, 221)",
                  padding: "30px 10px",
                  marginTop: "2rem",
                }}
              >
                <FormField width={16}>
                  <FormGroup inline={true}>
                    <FormField inline={true} width={7}>
                      <label style={{ width: "100%", maxWidth: "max-content" }}>
                        Nursing Diagnosis
                      </label>
                      <Dropdown
                        allowAdditions={true}
                        clearable={true}
                        fluid={true}
                        name="nursing_diagnosis"
                        onAddItem={handleAddOptions}
                        onChange={(_event: any, data: any) =>
                          props.setProp(
                            "PerioperativeNursingSequence.skinPreparation.data.nursing_diagnosis",
                            data.value
                          )
                        }
                        options={options.orNDOptions || []}
                        search={true}
                        selection={true}
                        style={{ width: "100%" }}
                        value={props.data?.data?.nursing_diagnosis}
                      ></Dropdown>
                    </FormField>
                    <FormField inline={true} width={8}>
                      <label>Goal</label>
                      <Dropdown
                        allowAdditions={true}
                        clearable={true}
                        fluid={true}
                        multiple={true}
                        name="goal"
                        onAddItem={handleAddOptions}
                        onChange={(_event: any, data: any) =>
                          props.setProp(
                            "PerioperativeNursingSequence.skinPreparation.data.goal",
                            data.value
                          )
                        }
                        options={options.orGoal || []}
                        search={true}
                        selection={true}
                        style={{ width: "100%" }}
                        value={props.data?.data?.goal || []}
                      ></Dropdown>
                    </FormField>
                    <FormField
                      inline={true}
                      width={1}
                      style={{
                        minWidth: "max-content",
                        padding: 0,
                        marginRight: "-0.5rem",
                      }}
                    ></FormField>
                  </FormGroup>
                  <FormGroup inline={true}>
                    <FormField inline={true} width={7}>
                      <label style={{ width: "100%", maxWidth: "max-content" }}>
                        Plan and implementation
                      </label>
                      <Dropdown
                        allowAdditions={true}
                        clearable={true}
                        fluid={true}
                        multiple={true}
                        name="plan_and_implementation"
                        onAddItem={handleAddOptions}
                        onChange={(_event: any, data: any) =>
                          props.setProp(
                            "PerioperativeNursingSequence.skinPreparation.data.plan_and_implementation",
                            data.value
                          )
                        }
                        options={options.planAndImpleHrOptions || []}
                        search={true}
                        selection={true}
                        style={{ width: "100%" }}
                        value={
                          props.data?.data?.plan_and_implementation || []
                        }
                      ></Dropdown>
                    </FormField>
                    <FormField inline={true} width={8}>
                      <label>Evaluation</label>
                      <Dropdown
                        allowAdditions={true}
                        clearable={true}
                        fluid={true}
                        multiple={true}
                        name="evaluation"
                        onAddItem={handleAddOptions}
                        onChange={(_event: any, data: any) =>
                          props.setProp(
                            "PerioperativeNursingSequence.skinPreparation.data.evaluation",
                            data.value
                          )
                        }
                        options={options.orEvaluation}
                        search={true}
                        selection={true}
                        style={{ width: "100%" }}
                        value={props.data?.data?.evaluation || []}
                      ></Dropdown>
                    </FormField>
                    <FormField inline={true} width={1}></FormField>
                  </FormGroup>
                </FormField>
              </FormGroup>
            </Form>
          </>
        }
        ButtonSave={
          <PreOPButtonAction
            setProp={props.setProp}
            data={{ [SKIN_PREPARATION]: props.data }}
            type="save"
            cardKey={SKIN_PREPARATION}
            buttonLoadCheck={props.buttonLoadCheck}
            onClick={handleSave(ACTION.SAVE)}
          />
        }
        ButtonConfirm={
          <PreOPButtonAction
            setProp={props.setProp}
            data={{ [SKIN_PREPARATION]: props.data }}
            type="confirm"
            cardKey={SKIN_PREPARATION}
            buttonLoadCheck={props.buttonLoadCheck}
            onClick={handleSave(ACTION.CONFIRM)}
          />
        }
        ButtonUnConfirm={
          <PreOPButtonAction
            setProp={props.setProp}
            data={{ [SKIN_PREPARATION]: props.data }}
            type="unconfirm"
            cardKey={SKIN_PREPARATION}
            buttonLoadCheck={props.buttonLoadCheck}
            onClick={handleSave(ACTION.UNCONFIRM)}
          />
        }
        languageUX={props.languageUX}
      />
    </>
  );
};

/**============================================
 **             SkinScrubAddData
 *=============================================**/
const SkinScrubAddData = (props: AddDataProps) => {
  const handleChange = (key: string) => (_event: any, data?: any) => {
    const value = typeof _event === "string" ? _event : data.value;
    props.onChangeData(props.index, value, key, props.type);
  };

  return (
    <FormGroup inline>
      <FormField inline width={5}>
        <Dropdown
          style={{ width: "100%" }}
          value={props.item?.skinArea}
          disabled={props.disabled}
          onChange={handleChange("skinArea")}
          selection={true}
          clearable={true}
          options={props.orSkinAreaOptions || []}
          allowAdditions={true}
          search={true}
          onAddItem={props.handleAddSkinAreaOptions}
        ></Dropdown>
      </FormField>
      <FormField inline width={1}>
        <label style={{ width: "100%", maxWidth: "max-content" }}>with</label>
      </FormField>
      <FormField inline width={8}>
        <Dropdown
          style={{ width: "100%" }}
          selection={true}
          onChange={handleChange("solution")}
          clearable={true}
          value={props.item?.solution || []}
          options={props.orVaginaOptions || []}
          name="vagina"
          search={true}
          multiple={true}
          allowAdditions={true}
          fluid={true}
          onAddItem={props.handleAddVaginaOptions}
        ></Dropdown>
      </FormField>
      <FormField inline style={{ display: "flex" }}>
        {props.index !== 0 && (
          <Button
            color="red"
            icon="minus"
            size="mini"
            disabled={props.disabled}
            style={{ margin: "0px 20px" }}
            onClick={() => props.onDeleteData(props.index, props.type)}
          ></Button>
        )}
        <Button
          color="blue"
          icon="plus"
          size="mini"
          disabled={props.disabled}
          style={props.index === 0 ? { margin: "0px 20px" } : { display: "none" }}
          onClick={() => props.onAddData(props.type)}
        ></Button>
      </FormField>
    </FormGroup>
  );
};

export default React.memo(CardSkinPreparation);
